<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;

    /**
     * Component is used to be a dropzone for draggable component
     * @property {String} key - mandatory property has to be unique in a set of DropAreas
     * @property {String} [draggableGroupKey] - draggableInstance key to attach DropArea to
     * @property {Boolean} [focusable=true] DropArea element should be programmatically focusable
     * @property {Boolean} [disabled=false] dragAndDrop operation is disabled
     * @property {Boolean} [suggested=false] DropArea should get suggested class for visuals
     * @fires update {CustomEvent} custom event fired when Draggable has been dropped to the DropArea
     * @fires dragOver {CustomEvent} custom event fired when Draggable enters DropArea
     * @fires dragOut {CustomEvent} custom event fired when Draggable leaves DropArea
     * @fires click {CustomEvent} custom event fired when Draggable has been clicked
     */
    import { dragAndDropAction } from '@oat-sa-private/ui-core';
    import { createEventDispatcher } from 'svelte';

    export let key;
    export let draggableGroupKey = 'draganddrop';
    export let focusable = true; //tabindex=-1 if true, no tabindex if false
    export let disabled = false;
    export let suggested = false;

    const dispatch = createEventDispatcher();

    function handleUpdate(e) {
        dispatch('update', e.detail);
        e.stopPropagation();
    }

    function handleOver(e) {
        dispatch('dragOver', e.detail);
        e.stopPropagation();
    }

    function handleOut(e) {
        dispatch('dragOut', e.detail);
        e.stopPropagation();
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-tabindex a11y-no-static-element-interactions -->
<div
    class="drop-area"
    class:suggested
    use:dragAndDropAction={{ disabled, draggableGroupKey, dropArea: true, key }}
    tabindex={focusable ? '-1' : void 0}
    on:update={handleUpdate}
    on:over={handleOver}
    on:out={handleOut}
    on:click>
    <slot />
</div>
